import React from "react";
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";

import AdminOnlyRoute from "./components/adminOnlyRoute/AdminOnlyRoute";
import NavBar from "./components/navBar/NavBar";
import NotFound from "./components/notFound/NotFound";
import OrderConfirm from "./components/orderConfirm/OrderConfirm";
import PrivateRoute from "./components/privateRoute/privateRoute";
import Settings from "./pages/adminDashboard/Settings";
import Users from "./pages/adminDashboard/Users";
import Checkout from "./pages/checkout/Checkout";
import Contact from "./pages/contact/Contact";
import ForgotPassword from "./pages/forgotPassword/ForgotPassword";
import Help from "./pages/help/Help";
import Homepage from "./pages/homepage/Homepage";
import Login from "./pages/login/Login";
import MyAccount from "./pages/myAccount/MyAccount";
import OrderHistory from "./pages/orderHistory/OrderHistory";
import Signup from "./pages/signup/Signup";
import { AuthProvider, OrderProvider } from "./services/context";
import "./theme/tailwind.css";

const App = () => {
  return (
    <div className="w-full h-full ">
      <AuthProvider>
        <OrderProvider>
          <Router>
            <NavBar />
            <Routes>
              {/* Protected Routes */}
              <Route path="/" element={<PrivateRoute element={Homepage} />} />
              <Route
                path="/checkout"
                element={<PrivateRoute element={Checkout} />}
              />
              <Route
                path="/orders"
                element={<PrivateRoute element={OrderHistory} />}
              />
              <Route
                path="/confirm"
                element={<PrivateRoute element={OrderConfirm} />}
              />

              {/* Admin Routes */}
              <Route
                path="/settings"
                element={<AdminOnlyRoute element={Settings} />}
              />
              <Route path="/users" element={<Users />} />

              {/* Public Routes */}
              <Route path="/login" element={<Login />} />
              <Route path="/my-account" element={<MyAccount />} />
              <Route path="/signup" element={<Signup />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/help" element={<Help />} />

              {/* Catch-all 404 */}
              <Route path="*" element={<NotFound />} />
            </Routes>
          </Router>
        </OrderProvider>
      </AuthProvider>
    </div>
  );
};

export default App;
